<template>
  <div class="row">
    <div class="flex xs10 offset--xs1">
      <va-card :title="title">
        <div class="row">
          <div class='flex md12 sm6 xs12'>
            <va-input
              v-model='insertData.id'
              v-show="showId"
              label='id'
              disabled
            />
          </div>
          <div class="flex xs6">
            <va-input
              v-model="insertData.name"
              label="群组名"
              removable
              :messages="message"
              :error="!!error.nameErrors.length"
              :error-messages="error.nameErrors"
            />
          </div>
          <div class="flex xs6">
            <va-input
              v-model="insertData.nameEn"
              label="群组名(英文)"
              removable
              :messages="message"
              :error="!!error.nameEnErrors.length"
              :error-messages="error.nameEnErrors"
            />
          </div>
          <div class="flex xs6">
            <va-input
                v-model="insertData.desc"
                label="描述"
                removable
                :messages="message"
                :error="!!error.descErrors.length"
                :error-messages="error.descErrors"
            />
          </div>
          <div class="flex xs6">
            <va-input
                v-model="insertData.descEn"
                label="描述(英文)"
                removable
                :messages="message"
                :error="!!error.descEnErrors.length"
                :error-messages="error.descEnErrors"
            />
          </div>
          <div class="flex xs4">
            <div class='flex md12 sm6 xs12' v-show="insertData.backgroundUrl.length!==0">
              <va-card
                overlay
                :image='insertData.backgroundUrl'
                class="va-card-image"
              >
              </va-card>
            </div>
            <div class="flex md12 sm6 xs12">
              <va-card title='群组背景图'>
                <va-file-upload
                  type='single'
                  v-model='insertData.backgroundUrlArr'
                  @input="uploadImage('backgroundUrl','backgroundUrlArr')"
                />
              </va-card>
            </div>
          </div>
          <div class="flex xs4">
            <div class='flex md12 sm6 xs12' v-show="insertData.infoUrl.length!==0">
              <va-card
                overlay
                :image='insertData.infoUrl'
                class="va-card-image"
              >
              </va-card>
            </div>
            <div class="flex md12 sm6 xs12">
              <va-card title='群组详情图'>
                <va-file-upload
                  type='single'
                  v-model='insertData.infoUrlArr'
                  @input="uploadImage('infoUrl','infoUrlArr')"
                />
              </va-card>
            </div>
          </div>
          <div class="flex xs4">
            <div class='flex md12 sm6 xs12' v-show="insertData.shareUrl.length!==0">
              <va-card
                overlay
                :image='insertData.shareUrl'
                class="va-card-image"
              >
              </va-card>
            </div>
            <div class="flex md12 sm6 xs12">
              <va-card title='群组分享图'>
                <va-file-upload
                  type='single'
                  v-model='insertData.shareUrlArr'
                  @input="uploadImage('shareUrl','shareUrlArr')"
                />
              </va-card>
            </div>
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.sortNum"
              label="排序"
              placeholder="数字越大越靠前"
              removable
              :messages="message"
              :error="!!error.sortNumErrors.length"
              :error-messages="error.sortNumErrors"
              type="number"
              :min="1"
            />
          </div>
        </div>

        <div class='flex md2 offset--md5'>
          <va-button class="ma-0" color="primary" slot="trigger" @click="clickSubmit" :disabled="!submitButtonStatus">
            submit
          </va-button>
        </div>

      </va-card>
    </div>
  </div>
</template>

<script>

import { copyObject } from '../../utils/common'
import groupApi from '../../api/group'
import uploadApi from '../../api/upload'

export default {
  data () {
    return {
      insertData: {
        id: null,
        backgroundUrlArr: [],
        backgroundUrl: '',
        infoUrlArr: [],
        infoUrl: '',
        shareUrlArr: [],
        shareUrl: '',
        name: '',
        nameEn: '',
        desc: '',
        descEn: '',
        sortNum: 1,
      },
      message: ['Required field'],
      error: {
        nameErrors: [],
        nameEnErrors: [],
        backgroundErrors: [],
        descErrors: [],
        descEnErrors: [],
        sortNumErrors: [],
      },
      title: '创建群组',
      showId: false,
      submitButtonStatus: true,
    }
  },
  created () {
    const params = this.$route.params
    console.log(params)
    if (params.id != null) {
      this.showId = true
      this.title = '编辑群组'
      // 通过id获取详情
      groupApi.getGroupInfo(params.id).then(response => {
        copyObject(response, this.insertData)
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    }
  },
  computed: {
    formReady () {
      return !this.error.nameErrors.length &&
          !this.error.nameEnErrors.length &&
          !this.error.descErrors.length &&
          !this.error.descEnErrors.length &&
          !this.error.sortNumErrors.length &&
          !this.error.backgroundErrors.length
    },
  },
  methods: {
    clickSubmit () {
      this.checkField()
      if (!this.formReady) {
        return
      }
      this.changeButtonStatus(false)
      const data = {
        name: this.insertData.name,
        nameEn: this.insertData.nameEn,
        desc: this.insertData.desc,
        descEn: this.insertData.descEn,
        backgroundUrl: this.insertData.backgroundUrl,
        infoUrl: this.insertData.infoUrl,
        shareUrl: this.insertData.shareUrl,
        sortNum: this.insertData.sortNum,
      }
      if (this.insertData.id !== null) {
        data.id = this.insertData.id
        groupApi.updateGroup(data).then(response => {
          this.$router.push({ name: 'listGroup' })
        }).catch(error => {
          this.changeButtonStatus(true)
          alert(error)
        })
      } else {
        groupApi.createGroup(data).then(response => {
          this.$router.push({ name: 'listGroup' })
        }).catch(error => {
          this.changeButtonStatus(true)
          alert(error.msg)
        })
      }
    },
    checkField () {
      this.error.nameErrors = this.insertData.name ? [] : ['name is required']
      this.error.nameEnErrors = this.insertData.nameEn ? [] : ['nameEn is required']
      this.error.descErrors = this.insertData.desc ? [] : ['desc is required']
      this.error.descEnErrors = this.insertData.descEn ? [] : ['descEn is required']
      this.error.sortNumErrors = this.insertData.sortNum ? [] : ['sortNum is required']
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
    uploadImage (key, keyArr) {
      console.log(key)
      console.log(keyArr)
      if (this.insertData[keyArr].length === 0) return

      const formData = new FormData()
      formData.append('type', 'image')
      formData.append('file', this.insertData[keyArr][this.insertData[keyArr].length - 1])
      uploadApi.uploadImage(formData).then(response => {
        console.log(response)
        this.insertData[key] = response.url
        this.showToast('上传图片成功', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },

  },
}

</script>

<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>
